import { render, staticRenderFns } from "./ShoppingList.vue?vue&type=template&id=6232c4d3&scoped=true&"
import script from "./ShoppingList.vue?vue&type=script&lang=js&"
export * from "./ShoppingList.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingList.vue?vue&type=style&index=0&id=6232c4d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6232c4d3",
  null
  
)

export default component.exports